/**
 * Tipo para la configuración de una base de datos
 */
type DatabaseConfig = Record<string, any>;

/**
 * Tipo para la configuración general del ORM
 */
interface ConfigData {
  [key: string]: any;
  databases?: Record<string, DatabaseConfig>;
}

/**
 * Clase para manejar la configuración del ORM
 */
export class Config {
  private data: ConfigData = {};
  private databases: Record<string, DatabaseConfig> = {};

  /**
   * Establece la configuración
   * @param configData - Datos de configuración
   */
  set(configData: ConfigData): void {
    this.data = configData;

    if (configData.databases) {
      this.databases = configData.databases;
    }
  }

  /**
   * Obtiene un valor de configuración
   * @param key - Clave de configuración
   * @returns Valor de configuración
   */
  get<T = any>(key: string): T {
    return this.data[key];
  }

  /**
   * Obtiene la configuración de una base de datos específica
   * @param dbName - Nombre de la base de datos
   * @returns Configuración de la base de datos o null
   */
  getDatabase(dbName: string): DatabaseConfig | null {
    return this.databases[dbName] || null;
  }

  /**
   * Obtiene todas las bases de datos configuradas
   * @returns Todas las configuraciones de bases de datos
   */
  getAllDatabases(): Record<string, DatabaseConfig> {
    return this.databases;
  }
}

export default Config;
